import { PLATFORMS } from 'pages/views/devices/types';

export interface Step {
  action: string;
  imageUrl: string;
  description: string;
}

export const installationSteps = {
  [PLATFORMS.MAC]: [
    {
      action: '1. Open the .dmg file',
      imageUrl: 'https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/devices/open-dmg.png',
      description: 'Go to your Downloads folder and open the .dmg file.',
    },
    {
      action: '2. Drag and Drop',
      imageUrl: 'https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/devices/drag-drop.png',
      description: 'Drag and drop the Hub app icon into the Applications folder.',
    },
    {
      action: '3. Open the app',
      imageUrl: 'https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/devices/open-app.png',
      description: 'Launch the Hub app from your Applications folder.',
    },
  ],
  [PLATFORMS.WINDOWS]: [
    {
      action: '1. Open the .exe file',
      imageUrl: 'https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/devices/open-exe.png',
      description: 'Go to your Downloads folder and open the .exe file.',
    },
    {
      action: '2. Grant Windows access ',
      imageUrl: 'https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/devices/grant-access.png',
      description: 'Click “More info” then “Run anyway” to allow Windows to run the Hub installer.',
    },
    {
      action: '3. Complete the installer',
      imageUrl: 'https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/devices/installer.png',
      description: 'The Hub app will automatically open when installation is complete.',
    },
  ],
};
